import React from 'react'
import { useStaticDataStore } from '../../stores/staticData';
import dummyCompany from '../../assets/images/dummyCompany.png'

const AcceleratorTab = ({ acceleratorData }) => {
    const { data: staticData } = useStaticDataStore();
    let industryTags = [];
    if (staticData?.industryTags?.length) {
        industryTags = staticData?.industryTags;
    }
    let startupStages = [];
    if (staticData?.startupStages?.length) {
        startupStages = staticData?.startupStages;
    }

    return (
        <div className='accelerators-edit-section'>
            <div className='accelerators-details'>
                <div className='accelerators-dummy-image'>
                    <img src={acceleratorData?.logo || dummyCompany} alt="accelerators dummy image" />
                </div>
                <div className='accelerators-detail-section accelerators-company-section'>
                    <div>
                        <span className='label'>Accelerator name</span>
                        <div className='value'>{acceleratorData?.name}</div>
                    </div>
                    <div>
                        <span className='label'>About the accelerator</span>
                        <div className='value'>{acceleratorData?.about}</div>
                    </div>
                    <div>
                        <span className='label'>Startups invested in</span>
                        <div className='value'>{acceleratorData?.investedIn}</div>
                    </div>
                    <div>
                        <span className='label'>LinkedIn page</span>
                        <div className='value'>{acceleratorData?.linkedInUrl}</div>
                    </div>
                    <div>
                        <span className='label'>Website</span>
                        <div className='value'>{acceleratorData?.website}</div>
                    </div>
                    <div>
                        <span className='label'>Industries</span>
                        <div className="value">
                            {acceleratorData?.industryTags?.map((key, idx) => {
                                const matched = industryTags?.find(item => item?.key === key);
                                return (
                                    <span key={key}>
                                        {matched?.value || key}
                                        {idx < acceleratorData.industryTags.length - 1 ? ', ' : ''}
                                    </span>
                                );
                            })}
                        </div>
                    </div>
                    <div>
                        <span className='label'>Startup stages</span>
                        <div className="value">
                            {acceleratorData?.startupStages?.map((key, idx) => {
                                const matched = startupStages?.find(item => item?.key === key);
                                return (
                                    <span key={key}>
                                        {matched?.value || key}
                                        {idx < acceleratorData.startupStages.length - 1 ? ', ' : ''}
                                    </span>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AcceleratorTab